import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../selectors/layout';

export function useDeviceCondition<D, M>(desktop: D, mobile: M): D | M {
  const isMobile = useSelector(selectIsMobileLayout);

  return isMobile ? mobile : desktop;
}
